const TutorialData = {
  "DEFAULT_OPTIONS": [
    {
      "name": "Brightness",
      "property": "brightness",
      "value": 110,
      "range": {
        "min": 20,
        "max": 200
      },
      "unit": "%",
      "status": false
    },
    {
      "name": "Contrast",
      "property": "contrast",
      "value": 110,
      "range": {
        "min": 20,
        "max": 200
      },
      "unit": "%",
      "status": false
    },
    {
      "name": "Saturation",
      "property": "saturate",
      "value": 110,
      "range": {
        "min": 20,
        "max": 200
      },
      "unit": "%",
      "status": false
    },
    {
      "name": "Grayscale",
      "property": "grayscale",
      "value": 0,
      "range": {
        "min": 0,
        "max": 100
      },
      "unit": "%",
      "status": false
    },
    {
      "name": "Sepia",
      "property": "sepia",
      "value": 0,
      "range": {
        "min": 0,
        "max": 100
      },
      "unit": "%",
      "status": false
    },
    {
      "name": "Hue Rotate",
      "property": "hue-rotate",
      "value": 0,
      "range": {
        "min": 0,
        "max": 360
      },
      "unit": "deg",
      "status": false
    },
    {
      "name": "Blur",
      "property": "blur",
      "value": 0,
      "range": {
        "min": 0,
        "max": 0.5
      },
      "unit": "px",
      "status": false
    }
  ],
  "Stages": [
    {
      "title": "Brightness",
      "link": "https://slider-fun.onrender.com/api/photo/65df9d29c142b57781704594",
      "infoText": "Adjusting brightness involves altering the overall lightness or darkness of an image. This can be particularly useful in low-light conditions to enhance image clarity, or in overly bright conditions to reduce glare and balance the exposure.",
      "extraText": "Commonly used in nature photography to bring out details in underexposed areas like dense forests or sunset scenes or in event photography, such as weddings or concerts, to compensate for varying lighting conditions."
    },
    {
      "title": "Contrast",
      "link": "https://slider-fun.onrender.com/api/photo/65df9deac142b577817046e7",
      "infoText": "Adjusting brightness involves altering the overall lightness or darkness of an image. This can be particularly useful in low-light conditions to enhance image clarity, or in overly bright conditions to reduce glare and balance the exposure.",
      "extraText": "Commonly used in nature photography to bring out details in underexposed areas like dense forests or sunset scenes or in event photography, such as weddings or concerts, to compensate for varying lighting conditions."
    },
    {
      "title": "Saturation",
      "link": "https://slider-fun.onrender.com/api/photo/65df9dffc142b577817046fc",
      "infoText": "Saturation editing alters the intensity of colors in a photo, increasing it can make colors more vivid and eye-catching, while decreasing it can give a more subdued, natural look.",
      "extraText": "Commonly applied in nature and travel photography to enhance natural colors, and in food photography to make the dishes appear more appetizing."
    },
    {
      "title": "Greyscale",
      "link": "https://slider-fun.onrender.com/api/photo/65df9facc142b57781704987",
      "infoText": "Converting a photo to greyscale removes all color, resulting in a black-and-white image, which is great for creating a timeless, classic look or focusing on textures and shapes.",
      "extraText": "Popular in street photography for its timeless quality and ability to focus on emotion and context, and in fine art photography for its dramatic and moody effect."
    },
    {
      "title": "Sepia",
      "link": "https://slider-fun.onrender.com/api/photo/65df9ff4c142b577817049b1",
      "infoText": "Applying a sepia tone gives photos a warm brown tint, reminiscent of vintage or historical photographs, often used to evoke nostalgia or age.",
      "extraText": "Frequently used in portrait photography to create a warm, nostalgic feel, and in documenting historical reenactments or antiques to enhance the vintage aesthetic."
    },
    {
      "title": "Hue Rotate",
      "link": "https://slider-fun.onrender.com/api/photo/65df9fd3c142b5778170499c",
      "infoText": "Hue rotation changes the overall color spectrum of an image, allowing for creative and dramatic shifts in appearance, useful for artistic effects or correcting color casts.",
      "extraText": "Utilized in artistic and abstract photography to create surreal and visually striking images, and in advertising to grab attention with unusual color schemes."
    },
    {
      "title": "Blur",
      "link": "https://slider-fun.onrender.com/api/photo/65dfa01bc142b577817049c6",
      "infoText": "Adding blur to a photo can soften edges, create a sense of motion, or bring focus to a particular element by reducing background detail.",
      "extraText": "Widely used in sports and action photography to convey motion and speed, and in portrait photography to isolate the subject from a distracting background."
    }
  ]
}

export default TutorialData;